import { render, staticRenderFns } from "./UsersViewedReports.vue?vue&type=template&id=a07668e6&scoped=true"
import script from "./UsersViewedReports.vue?vue&type=script&lang=js"
export * from "./UsersViewedReports.vue?vue&type=script&lang=js"
import style0 from "./UsersViewedReports.vue?vue&type=style&index=0&id=a07668e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07668e6",
  null
  
)

export default component.exports